import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useRecorderAuth from '../hooks/useRecorderAuth';

export default function RecorderProtectedRoute() {
  const { bootstrapping, isAuthenticated } = useRecorderAuth();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-300">
        <div className="bg-white shadow-xl p-8 rounded-2xl border border-gray-200 text-gray-700">
          Loading recorder...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search || ''}`;
    return (
      <Navigate
        to={`/recorder-login?returnTo=${encodeURIComponent(returnTo)}`}
        replace
        state={{ returnTo }}
      />
    );
  }

  return <Outlet />;
}
